'use client';

import * as React from 'react';
import Link from 'next/link';
import { useAtomValue } from 'jotai';
import { pathPrefixAtom } from '../../_components/blog-state';
import { designAtom } from '../../_components/design-state';

export type PostLinkProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  'aria-label'?: string;
};

export function PostLink(props: PostLinkProps): JSX.Element {
  const urlPrefix = useAtomValue(pathPrefixAtom);
  const isDesignMode = useAtomValue(designAtom);
  return (
    <Link
      className={props.className}
      href={`${urlPrefix}${props.href}`}
      aria-label={props['aria-label']}
      prefetch={isDesignMode.enabled ? false : null}
    >
      {props.children}
    </Link>
  );
}
